<template>
	<div class="">
		<div class="flex pos-re">
			<div>
				<img :src="dataInfo.photo_image" alt="" class="teacher-avatar" />
				<div class="flex mt-3 justify-content-between">
					<div class="flex">
						<img src="../../assets/image/commom/star-rating.png" alt="" style="width: 45px;height: 45px;" />
						<div>
							<div class="cl-theme ft16 ftw600">MIRA</div>
							<div class="ft14 cl-17AAEA">STAR TUTOR</div>
							<div class="ft14 cl-17AAEA">AWARD</div>
						</div>
						
					</div>
					<div>
						<div style="color: #BF9002;">星級</div>
						<div style="color: #BF9002;">老師</div>
						<div class="cl-info">4次</div>
					</div>
				</div>
			</div>
			
			<div class="ps-3">
				<div class=" flex alcenter">
					{{dataInfo.name}} {{dataInfo.surname}}
					<img src="../../assets/image/commom/proofId.png" alt="" class="teacherDetails-icon ml10" />
					<img src="../../assets/image/commom/star-rating.png" alt="" class="teacherDetails-icon" />
				</div>
				<div class="ft14 mt-2 cl-theme">
					{{dataInfo.synopsis}}
				</div>
				<div class="flex align-items-center ftw600 mt-2">
					<div class="tag-blue px-2 mr10"> {{$t('forClassIndex.professionalTeacher')}}</div>
					<div class="tag-yellow px-2 mr10">  {{dataInfo.education_background_name}} </div>
					<div class="tag-orange px-2 mr10"> {{dataInfo.teacher_level_name}} </div>
				</div>
				<div class="flex wrap align-items-center mt-2 ft14 ftw600">
					<img src="../../assets/image/teacher/icon1.png" alt="" class="icon-js" />
					<div class="flex">
						<div v-for="(t,i) in dataInfo.professor_level_names"> <span v-if="i != 0">|</span> {{t}} </div>
					</div>
				</div>
				<div class="flex align-items-center mt-1 ft14 ftw600">
					<img src="../../assets/image/teacher/icon2.png" alt="" class="icon-js" />
					<div class="wid-fit border-theme px-2 ft14 me-2 mt-1"  v-for="(t,i) in dataInfo.teacher_course">
						{{t}}
					</div>
				</div>
				<!-- <div class="flex align-items-center mt-1 ft14 ftw600">
					<img src="../../assets/image/teacher/icon3.png" alt="" class="icon-js" />
					<div>
						前DSE評卷員｜自製筆記｜有耐性｜課後答疑｜數學MC神技
					</div>
				</div> -->
				<div class="flex  mt-1 ft14 ftw600">
					<img src="../../assets/image/teacher/icon4.png" alt="" class="icon-js mt-2" />
					<div>
						<div class="flex">
							<div class="wid-fit border px-2 ft14 me-2 mt-1" v-for="(t,i) in dataInfo.teacher_language">
								{{t.language_name}}({{t.language_level_name}})
							</div>
						</div>
						
						<!-- <div>自閉症譜系｜過度活躍症｜讀寫障疑</div> -->
					</div>
					
				</div>
				
				<!-- <div class="cl-info ft14 mt-2">
					{{$t('forClassIndex.professionalTeacher')}}
					 <span class="wid-fit bg-pink ft14 cl-w py-0 px-1">{{$t('forClassIndex.seniorTutor')}}</span>
				</div>
				
				<div class="flex align-items-center mt-2 ft14 ">
					<img src="../../assets/image/class/start.png" alt="" class="teacherDetails-icon" />
					4.9
					<span class="cl-info">(19)</span>
				</div>
				<div class="flex align-items-center mt-2 ft14 ">
					<img src="../../assets/image/teacher/jiangbei.png" alt="" class="teacherDetails-icon" />
					2{{$t('forClassIndex.highQualityMentor')}}
				</div> -->
			</div>
			<!-- <button type="button" class="btn btn-outline-gray px-4 py-2 pos-ab" style="bottom: 0px;right: 10px;" @click="openKefu(dataInfo.user_id)">{{$t('common.contactTeacher')}}</button> -->
		</div>
		
		<div class="ftw600 ft16 mt-3">
			{{$t('teacherVue.achievementSharing')}}
		</div>
		<div class="text-center">
			<div class="flex mt-3">
				<div class="text-center" v-for="item in dataInfo.introduce_images">
					<img :src="item" alt="" style="width: 150px; margin-left: 15px;" />
					<!-- <div class="mt-2">
						Maths 全級第1
					</div> -->
				</div>
			</div>
			<!-- <div class="btn btn-outline-theme mt-3">
				{{$t('common.showMore')}}
			</div> -->
		</div>
		<div v-if="showPart == ''">
			<div class="ftw600 ft16 mt-3">
				{{$t('teacherVue.evaluate')}}
			</div>
			
			<div class="flex alcenter mt-3">
				<a-rate disabled :count="1" :value="1" style="font-size: 20px;" />
				<div class="ftr-1-25 ftw600 mr10">4.9</div>
				<div class="ftr-1-25 ftw600 cl-theme">{{$t('teacherVue.outstanding')}}</div>
				<div class="cl-info ml10" style="font-size: 14px;">
					240{{$t('teacherVue.studentEvaluation')}}
				</div>
			</div>
			<div class="mt-3" v-for="(item,index) in commentList" >
				<div v-if="index<2" class="mt-2">
					<div class="flex alcenter justify-content-between ">
						<div class="flex"> 
							<img :src="item.user_info.avatar" class="mr10" alt="" style="width: 50px;height: 50px; border-radius: 50%;" />
							<div>
								<div class="cl-black">
									{{item.user_info.nickname}}
								</div>
								<div class="ft14 cl-info mt-1 ">
									{{item.createtime}}
								</div>
								<div class="flex wrap " style="width: 370px;">
									<div class="bg-F3F3F3 mr10 cl-black px-2 mt-2" v-for="t in item.tagList">
										{{t}}
									</div>
								</div>
							</div>
						</div>
						<div>
							<a-rate v-model:value="item.score" disabled />
						</div>
					</div>
					<div class="cl-info mt-2">
						{{item.content}}
					</div>
				</div>
			</div>
			<div class="ft16 ftw600 cl-black mt-4">
				<!-- 影片介紹 -->
				{{$t('teacherVue.videoIntroduction')}}
			</div>
			<div class="mt-3">
				<div class="flex">
					<div v-for="item in dataInfo.video_files">
						<!-- 添加视频播放器 -->
						<video width="240" height="160" controls class="me-md-2 mr10">
							<source :src="item" type="video/mp4">
							{{$t('teacherVue.cannotPlay')}}
						</video>
						<div class="ft16 mt-2">{{'我的介紹'}}</div>
					</div>
					
				</div>
				
			</div>
			<a-tabs v-model:activeKey="activeKey" class=" mt-3">
				<a-tab-pane key="1" :tab="$t('teacherVue.aboutMe')">
					<div class="ftr-1" v-html="dataInfo.self_introduction_content">
					</div>
				</a-tab-pane>
				<!-- 學歷 -->
				<a-tab-pane key="6" :tab="$t('teacherSet.educationBackground')">
					<div class="flex ftr-1">
						<div>
							1994 - 1997
						</div>
						<div class="ms-4">
							<div class="cl-black"> Hong Kong University</div>
							<div class="cl-theme">
								{{$t('teacherVue.providedTeacher')}}
							</div>
						</div>
					</div>
				</a-tab-pane>
				<!-- 工作經驗 -->
				<a-tab-pane key="7" :tab="$t('becomeTeacher.workExperience')">
					<div class="flex ftr-1">
						<div>
							1994 - 1997
						</div>
						<div class="ms-4">
							<div class="cl-black"> Hong Kong University</div>
							<div>教師</div>
							<div class="cl-theme">
								{{$t('teacherVue.providedTeacher')}}
							</div>
						</div>
					</div>
				</a-tab-pane>
				<!-- 專業資格證書 -->
				<a-tab-pane key="8" :tab="$t('teacherVue.pQCertificate')">
					<div class="flex ftr-1">
						<div>
							1994
						</div>
						<div class="ms-4">
							<div class="cl-black"> Hong Kong University</div>
							<div>註冊教師資格證</div>
							<div class="cl-theme">
								{{$t('teacherVue.providedTeacher')}}
							</div>
						</div>
					</div>
				</a-tab-pane>
				<!-- 專業資格證書 -->
				<a-tab-pane key="9" :tab="$t('becomeTeacher.educationBackground16')">
					<div class="flex ftr-1">
						<div>
							1994
						</div>
						<div class="ms-4">
							<div class="cl-black"> Hong Kong University</div>
							<div>註冊教師資格證 <span class="ml20">A</span></div>
							<div>註冊教師資格證 <span class="ml20">A</span></div>
							<div>註冊教師資格證 <span class="ml20">A</span></div>
						</div>
						<div class="cl-theme ms-3">
							{{$t('teacherVue.providedTeacher')}}
						</div>
					</div>
				</a-tab-pane>
				
				<!-- <a-tab-pane key="4" :tab="$t('teacherVue.resume')">
					<div class="d-flex flex-wrap">
						<img :src="item" alt="" v-for="(item,index) in dataInfo.certificate_image" class="br4 mr10 border" style="width: 100px;height: 100px;" />
					</div>
				</a-tab-pane> -->
			</a-tabs>
			<div class="ft16 ftw600 cl-black mt-4">
				{{$t('teacherVue.classTime')}}
			</div>
			<div class="mt-3" v-if="teacherTime.length!=0">
				<class-time :isShow="true" fontSize="ft14" :classTime="teacherTime"></class-time>
			</div>
		</div>
		
		
		
		<!-- 開於 {{dataInfo.name}} {{dataInfo.surname}}的资讯 -->
		<!-- <div class=" ftw600 ft16 mt-5">
			
			{{$t('teacherVue.information',{name:dataInfo.name + dataInfo.surname})}}
		</div>
		<div class="pb-4 pt-3 border-b row ft16 flex alcenter ">
			<div class="col-md-2 mt-2">
				{{$t('teacherVue.teachingSubjects')}}
			</div>
			<div class="col-md flex align-items-center mt-2">
				<div class="border-theme py-1 px-2 cl-theme">
					{{dataInfo.language.name}}
				</div>
			</div>
		</div>
		<div class="pb-4 pt-3 border-b row ft16 flex alcenter ">
			<div class="col-md-2 mt-2">
				{{$t('teacherVue.professorlevel')}}
			</div>
			<div class="col-md flex align-items-center mt-2">
				<div class="border-gray py-1 px-2 bg-F3F3F3">
					{{dataInfo.professor_level.name}}
				</div>
			</div>
		</div>
		<div class="pb-4 pt-3 border-b row ft16 flex alcenter ">
			<div class="col-md-2 mt-2">
				{{$t('forClassIndex.speek')}}
			</div>
			<div class="col-md flex align-items-center mt-2">
				<div class="border-gray py-1 px-2 bg-F3F3F3">
					{{dataInfo.language.name}}
				</div>
			</div>
		</div>
		<div class="pb-4 pt-3 border-b row ft16 flex alcenter ">
			<div class="col-md-2 mt-2">
				{{$t('teacherVue.highestEducationLevel')}}
			</div>
			<div class="col-md flex align-items-center mt-2">
				<div class="border-gray py-1 px-2 bg-F3F3F3">
					{{dataInfo.education_background.name}}
				</div>
			</div>
		</div>
		<div class="pb-4 pt-3 row ft16">
			<div class="col-md-2 mt-2">
				{{$t('teacherVue.experience')}}
			</div>
			<div class="col-md flex align-items-center mt-2">
				<div class="border-gray py-1 px-2 bg-F3F3F3">
					{{dataInfo.special_educational_experience.name}}
				</div>
			</div>
		</div> -->
		
		
		
	</div>
</template>


<script>
	import classTime from './classTime.vue';
	export default {
		components:{
			classTime
		},
		props: {
			// dataInfo: {
			// 	type: Object,
			// 	default: {},
			// },
			teacher_id:{
				type:Number,
				default:0
			},
			showPart:{ //判断展示哪个部分 1：简介和教学成果分享
				type:String,
				default:''
			}
		},
		data() {
			return {
				activeKey: '1',
				commentList:[],
				num:1,
				teacherTime:[],
				dataInfo:{}
			}
		},
		created(){
			this.getTeacherDeatail()
		},
		methods:{
			teacherCommentList(){
				this.$http.api('teachers/teacherCommentList',{
					page:1,
					limit:5,
					teacher_id:this.dataInfo.id,
				}).then(res=>{
					this.commentList = res.list.map(item=>{
						item.score = Number(item.score)
						item.tagList = item.tags.split(",")
						return item
					})
				})
			},
			async getTeacherDeatail(){
				await this.$http.api('teachers/teacherDeatail',{
					teacher_id:this.teacher_id
				}).then(res=>{
					this.dataInfo = res.info
					this.teacherTime = res.info.teacher_time
					console.log("--this.teacherTime",this.teacherTime);
					this.teacherCommentList()
				})
			},
		}
	}
</script>

<style>
	.icon-js{
		width: 20px;
		height: 20px;
		margin-right: 10px;
	}
	.ant-tabs-nav .ant-tabs-tab {
		font-size: 16px;
	}

	.ant-tabs-nav .ant-tabs-tab:hover {
		color: #52C4C9;
	}

	.ant-tabs-nav .ant-tabs-tab-active {
		color: #52C4C9;
		text-shadow: 0 0 0.25px #52C4C9
	}

	.ant-tabs-ink-bar {
		background-color: #52C4C9;
	}

	.teacherDetails-icon {
		width: 20px;
		height: 20px;
		margin-right: 10px;
	}

	@media (max-width:575.98px) {
		.main-wid-100 {
			width: 100% !important;
		}

		.p-6 {
			padding-left: 1.5rem !important;
			padding-right: 1.5rem !important;
		}

		.teacher-avatar {
			width: 80px;
			height: 80px;
		}
	}

	@media (min-width:575.98px) {
		.teacher-avatar {
			width: 150px;
			height: 150px;
		}
	}
</style>